// Constants

/**
 * Custom options for custom scoring connection method
 */
export const httpConnectionOptions = [
  { label: 'GET', id: 'get' },
  { label: 'POST', id: 'post' },
  { label: 'PATCH', id: 'patch' },
  { label: 'PUT', id: 'put' }
];
